import { Pill } from '@/components/ui/pill'

export type TaskStatus = 'Draft' | 'Submitted' | 'Read'

export type TaskDerivedLabel = 'Draft' | 'Submitted' | 'Read'

interface TaskStatusBadgeProps {
  status: TaskStatus
  derived?: TaskDerivedLabel
  className?: string
}

const variants: Record<TaskDerivedLabel, 'warning' | 'success' | 'info'> = {
  Draft: 'warning',
  Submitted: 'success',
  Read: 'info',
}

export function TaskStatusBadge({ status, derived, className }: TaskStatusBadgeProps) {
  const label = derived ?? deriveLabel(status)
  return (
    <Pill variant={variants[label]} className={className}>
      {label}
    </Pill>
  )
}

function deriveLabel(status: TaskStatus): TaskDerivedLabel {
  if (status === 'Read') return 'Read'
  if (status === 'Submitted') return 'Submitted'
  return 'Draft'
}
